export default {
  // check auth
  get: function get() {
    return localStorage.getItem('ozeitManager') ? localStorage.getItem('ozeitManager') : false;
  },
  login: function login(data) {
    if (process.env.NODE_ENV === 'development') {
      localStorage.setItem('ozeitManager', true);
    } else {
      localStorage.setItem('ozeitManager', true);
    }
  },
  logout: function logout() {
    localStorage.removeItem('ozeitManager');
  }
};